import { render } from "./FiltrosContainer.vue?vue&type=template&id=2e63aca0&scoped=true&ts=true"
import script from "./FiltrosContainer.vue?vue&type=script&lang=ts"
export * from "./FiltrosContainer.vue?vue&type=script&lang=ts"

import "./FiltrosContainer.vue?vue&type=style&index=0&id=2e63aca0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e63aca0"]])

export default __exports__